export default "__VITE_ASSET__CAc0G7bl__"